import { Draggable } from "@hello-pangea/dnd";
import { fmtCurrency, fmtDate } from "@/lib/format";
import { cn } from "@/lib/utils";
import { GripVertical } from "lucide-react";

export default function DealCard({ deal, index, canMove, onOpen }) {
  return (
    <Draggable draggableId={deal.id} index={index} isDragDisabled={!canMove}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => onOpen(deal)}
          data-testid={`deal-card-${deal.id}`}
          className={cn(
            "w-full text-left bg-white rounded-lg border p-3 shadow-sm select-none",
            "transition-[box-shadow,border-color] duration-150 hover:shadow-md hover:border-teal/40",
            canMove ? "cursor-grab active:cursor-grabbing" : "cursor-pointer",
            snapshot.isDragging ? "border-teal shadow-lg ring-2 ring-teal/20 rotate-1" : "border-slate-200"
          )}
        >
          <div className="flex items-start gap-2">
            {canMove && <GripVertical className="h-4 w-4 text-slate-300 mt-0.5 shrink-0" />}
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-sm text-slate-800 truncate">{deal.title}</div>
              <div className="text-xs text-slate-400 mt-1 truncate">{deal.owner_name || "—"} · {fmtDate(deal.created_at)}</div>
              <div className="flex items-center justify-between mt-2">
                <span className="text-sm font-bold text-teal">{fmtCurrency(deal.amount)}</span>
                {deal.payment_verified && <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 rounded px-1.5 py-0.5">VERIFIED</span>}
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
}
